(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxPrintQueueNetworkList(
    toastr, $filter, NetworkListPOSTPaging, NetworkListService, $http, $timeout, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        me: '=me',
        isThisResourceMine: '=isThisResourceMine',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printQueueProperties/settings/networkList/printQueueNetworkList.template.html',
      link: function(scope) {

        scope.networkListPaging = new NetworkListPOSTPaging();
        scope.focusMe = false;
        scope.searchString = '';

        var scrollEnd = null;
        var containerHeight = null;
        var embed = '&embed=site';

        (function() {
          setFocus();
          getFirstPage(makeArraOfIds());
        })();

        function setFocus () {
          $timeout(function () {
            scope.focusMe = true;
          }, 300)
        }

        function makeArraOfIds () {
          var includes = [];
          if (Array.isArray(scope.context.printQueue.info._links['px:releaseFromOtherNetwork'])) {
            angular.forEach(scope.context.printQueue.info._links['px:releaseFromOtherNetwork'], function (network) {
              includes.push(network.href);
            })
          } else {
            if (scope.context.printQueue.info._links['px:releaseFromOtherNetwork']) {
              includes.push(scope.context.printQueue.info._links['px:releaseFromOtherNetwork'].href)
            }
          }
          return includes;
        }

        function getFirstPage (networkIds) {
          if (networkIds.length > 0) {
            scope.networkListPaging.pagingCriteria.networkIds = networkIds;
            scope.networkListPaging.pagingCriteria.pageSize = 10;
            scope.loadingPage = true;
            NetworkListService.getNetworkListPagedByPost(scope.networkListPaging, embed).then(function(response) {
              window.scrollTo(0,0);
              scope.totalPages = response.page.totalPages;
              scope.list = response.list
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.networkListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.networkListPaging.pagingCriteria.page += 1;
            NetworkListService.getNetworkListPagedByPost(scope.networkListPaging, embed).then(function(response){
              if (response.list) {
                scope.list = scope.list.concat(response.list);
              }
              scope.loadingPage = false;
            }).catch(function(error){});
          }
        }

        scope.textSearch = function () {
          scope.networkListPaging.pagingCriteria.match = scope.searchString;
          getFirstPage(makeArraOfIds());
        }


        angular.element('.pagination-content').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.networkListPaging.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.pagination-content').off('scroll');
        });


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LIST MENU
        ////////////////////////////////////////////
        scope.openListMenu = function (event, queue) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            scope.closeListMenu();
            scope.listMenuContext = queue;
            scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'networkList',
              // title: 'NUMSE',
              scrollContainerId: 'GroupScrollContainer',
              dontAllowDelete: true
            }
            scope.$apply();
          }, 50)
        }

        scope.closeListMenu = function (network, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;

          switch (action) {
            case 'DELETE_NETWORK':
              removeNetwork(network);
            break;
          }
        }

        function removeNetwork (network) {
          $rootScope.$broadcast('PRINT_QUEUE_SAVE_ENFORCED', scope.context.printQueue.info._links.self.href );

          var url = scope.context.printQueue.info._links['px:releaseFromOtherNetworks'].href;
          var networkUrl = [];

          networkUrl.push(network.customProperties.id);
          $http.delete(url, {
            headers: {
              "Content-Type": "application/json"
            },
            data: networkUrl
          }).then(function(response) {
            toastr.success($filter('translate')('Deleted'))
            removeItemFromList(network);
          }).catch(function(error) {
            console.log(error);
          });

        }

        function removeItemFromList (network) {
          for (var i = 0; i < scope.list.length; i++) {
            if (network.info._links.self.href === scope.list[i].info._links.self.href) {
              scope.list.splice(i, 1);
              break;
            }
          }
        }

        scope.addItemDialog = function (event) {
          scope.callback({context:
            {
              link: scope.context.link,
              event: event,
              type: 'addToNetwork',
              dontUseTitle: true,
              dontUseName: false,
              printQueue: scope.context.printQueue,
              name: scope.context.printQueue.info.name,
              title: 'AddNetwork'
            }});
        }

        scope.removeItemDialog = function (event) {
          scope.callback({context:
            {
              // groups : scope.context.groups,
              link: scope.context.link,
              event: event,
              type: 'removeNetworksFromQueue',
              printQueue: scope.context.printQueue,
              dontUseTitle: true,
              dontUseName: false,
              title: 'RemoveNetworks',
              name: scope.context.printQueue.info.name
            }});
        }

      }
    };
  }

  pxPrintQueueNetworkList.$inject = [
    'toastr', '$filter', 'NetworkListPOSTPaging', 'NetworkListService', '$http', '$timeout', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrintQueueNetworkList', pxPrintQueueNetworkList);

})();
